import { AppConfig } from '../services/app-config.service'
import * as Trait from './traits'
import * as DomainObject from './domain-object.model'

export type T = DomainType
type DomainType = Configured | NotConfigured

type Configured = Global<Partial<Trait.T>>
type NotConfigured = {name: string}

const NotConfigured = (name: string): NotConfigured => ({ name })
export const isConfigured = (type: DomainType): type is Configured => (type as unknown as Configured).traits !== undefined

export type DisplayableAttribute = {
  id: string,
  label: string
  quantity?: string
  unit: string
}

export type Global<Traits extends Partial<Trait.T>> = {
  name: string,
  traits: Traits
}

export const forDomainObject = (domainObject: DomainObject.T, domainTypeList: DomainType[]): DomainType => {
  const domainType =  domainTypeList.find(domainType => domainType.name === domainObject.type)
  if(domainType === undefined) {
    console.warn(`domain type not found in config: ${domainObject.type}`)
    return NotConfigured(domainObject.type)
  }
  return domainType
}

export const collectFromConfig = (appConfig: AppConfig): Configured[] => Object.keys(appConfig.domain.types).map(domainTypeName => ({
  name  : domainTypeName,
  traits: appConfig.domain.types[domainTypeName].traits
}))

export const traitsNamesOf = (type: DomainType): Trait.Name[] => isConfigured(type) ? Object.keys(type.traits) as Trait.Name[] : []
export const traitsOf = <NeededTrait extends Partial<Trait.T>>({ traits }: Global<NeededTrait>): NeededTrait => traits
export const hasTrait = (domainType: DomainType, traitName: Trait.Name): boolean => traitsNamesOf(domainType).includes(traitName)
